const REGULAR_SEASON = 'R'
const WILD_CARD = 'F'
const DIVISION_SERIES = 'D'
const CHAMPIONSHIP_SERIES = 'L'
const WORLD_SERIES = 'W'
const ALL_STAR = 'A'
const SPRING_TRAINING = 'S'
const PLAYOFFS = 'P'

const GAME_TYPES = {
    REGULAR_SEASON,
    PLAYOFFS,
    WILD_CARD,
    DIVISION_SERIES,
    CHAMPIONSHIP_SERIES,
    WORLD_SERIES,
    ALL_STAR,
    SPRING_TRAINING,
}

const POSTSEASON_GAME_TYPES = [
    PLAYOFFS,
    WILD_CARD,
    DIVISION_SERIES,
    CHAMPIONSHIP_SERIES,
    WORLD_SERIES,
]

const REGULAR_AND_POSTSEASON_GAME_TYPES = [
    REGULAR_SEASON,
    ...POSTSEASON_GAME_TYPES,
]

const GAME_TYPE_NAMES = {
    [REGULAR_SEASON]: 'Regular Season',
    [WILD_CARD]: 'Wild Card',
    [DIVISION_SERIES]: 'Division Series',
    [CHAMPIONSHIP_SERIES]: 'Championship Series',
    [WORLD_SERIES]: 'World Series',
    [ALL_STAR]: 'All Star',
    [SPRING_TRAINING]: 'Spring Training',
}

module.exports = {
    GAME_TYPES,
    GAME_TYPE_NAMES,
    POSTSEASON_GAME_TYPES,
    REGULAR_AND_POSTSEASON_GAME_TYPES,
}
